export function formatCurrencyShort(value) {
  const n = Number(value) || 0;
  const abs = Math.abs(n);
  if (abs >= 1000000) {
    return `€${(n / 1000000).toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} Mio`;
  }
  if (abs >= 1000) {
    return `€${Math.round(n / 1000).toLocaleString("de-DE")}k`;
  }
  return `€${Math.round(n).toLocaleString("de-DE")}`;
}
